import React from 'react'
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material'

interface RadioGroupLabeledProps<T extends string> {
    label: string
    onChange: (value: T) => void
    options: Record<T, string>
    value: T
}

const RadioGroupLabeled = <T extends string>({ label, onChange, options, value }: RadioGroupLabeledProps<T>) => {
    const handleChange = (_: unknown, value: string) => {
        onChange(value as T)
    }
    const name = label.replace(' ', '-')
    const labelId = `${name}-label`

    return (
        <FormControl>
            <FormLabel id={labelId}>{label}</FormLabel>
            <RadioGroup aria-labelledby={labelId} name={name} row onChange={handleChange} value={value}>
                {Object.keys(options).map((key) => (
                    <FormControlLabel key={key} value={key} control={<Radio />} label={options[key as T]} />
                ))}
            </RadioGroup>
        </FormControl>
    )
}

export default RadioGroupLabeled
